// extracted by mini-css-extract-plugin
export default {"patientsToolbarContainer":"ToolbarPatientsSelector_patientsToolbarContainer__Og3eZ","columnsToolbar":"ToolbarPatientsSelector_columnsToolbar__iXTbM"};